import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/undoRedo'

const state = {
    ...baseState,
}

const getters = {
    ...baseGetters,
}

const actions = {
    ...baseActions,
}

const mutations = {
    ...baseMutations,
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}